<template>
    <div class="container">
        <van-nav-bar
            title="电子日志"
            left-arrow
            @click-left="onClickLeft"
            fixed
        />
        <van-tabs
            v-model="status"
            class="log-box"
            animated
            swipeable
            line-height="2px"
            color="#54aadf"
            background="none"
            title-active-color="#54aadf"
        >
            <van-tab title="全部">
                <van-cell-group
                    v-for="item in list"
                    :key="item.id"
                    :class="
                        item.status === '已同步'
                            ? 'synchronized'
                            : 'not-synchronized'
                    "
                >
                    <van-cell
                        :title="'已学习' + item.duration + '分钟'"
                        :value="item.status"
                        class="state"
                    />
                    <van-cell :value="'日期：' + item.e_time2" />
                </van-cell-group>
            </van-tab>
            <van-tab title="已同步">
                <van-cell-group
                    v-for="item in list"
                    :key="item.id"
                    :class="
                        item.state === '已同步'
                            ? 'synchronized'
                            : 'not-synchronized'
                    "
                >
                    <div v-if="item.status === '已同步'">
                        <van-cell
                            :title="'已学习' + item.duration + '分钟'"
                            :value="item.status"
                            class="state"
                        />
                        <van-cell :value="'日期：' + item.e_time2" />
                    </div>
                </van-cell-group>
            </van-tab>
            <van-tab title="未同步">
                <van-cell-group
                    v-for="item in list"
                    :key="item.id"
                    :class="
                        item.status === '已同步'
                            ? 'synchronized'
                            : 'not-synchronized'
                    "
                >
                    <div v-if="item.status === '未同步'">
                        <van-cell
                            :title="'已学习' + item.duration + '分钟'"
                            :value="item.status"
                            class="state"
                        />
                        <van-cell :value="'日期：' + item.e_time2" />
                    </div>
                </van-cell-group>
            </van-tab>
        </van-tabs>
    </div>
</template>
<script>
import { getlist } from "@/api/studytime";
export default {
    data() {
        return {
            status: 0,
            list: [],
            subjectid: 1
        };
    },
    created() {
        this.subjectid = parseInt(this.$route.query.subject_id);
        this.getData();
    },
    methods: {
        onClickLeft() {
            this.$router.go(-1);
        },
        getData() {
            getlist({ subject_id: this.subjectid }).then(res => {
                this.list = res.data;
            });
        }
    }
};
</script>

<style scoped lang="scss">
.container {
    .van-tabs__nav {
        background: #f5f5f5;
    }
    .log-box {
        margin-top: 51px;
        .van-cell-group {
            width: 94%;
            margin-left: 3%;
            margin-top: 10px;
            border-radius: 5px;
            .van-cell__value--alone {
                color: #666;
            }
        }
        .synchronized {
            border-left: 3px solid #20a843;
            .state {
                .van-cell__value {
                    color: #20a843;
                }
            }
        }
        .not-synchronized {
            border-left: 3px solid #f12626;
            .state {
                .van-cell__value {
                    color: #f12626;
                }
            }
        }
    }
}
</style>
